import { CasesRepository } from '../repositories/cases.repository'
import { CasesGetListParams, CasesGetListResponse, CasesGetCaseDetailsResponse } from '../types/cases.types'

const casesRepository = new CasesRepository()

export class CasesService {
    async getCases(params: CasesGetListParams): Promise<CasesGetListResponse> {
        const response = await casesRepository.getCases(params)
        return response.data
    }

    async getCase(caseId: number): Promise<CasesGetCaseDetailsResponse> {
        const response = await casesRepository.getCase(caseId)
        return response.data
    }

    async createCase(payload: FormData): Promise<void> {
        const response = await casesRepository.createCase(payload)
        return response.data
    }

    async updateCase(caseId: number, payload: FormData): Promise<void> {
        const response = await casesRepository.updateCase(caseId, payload)
        return response.data
    }

    async deleteCase(caseId: number): Promise<void> {
        const response = await casesRepository.deleteCase(caseId)
        return response.data
    }
}